import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=cc38854a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=cc38854a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc38854a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc38854a')) {
      api.createRecord('cc38854a', component.options)
    } else {
      api.reload('cc38854a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=cc38854a&scoped=true&", function () {
      api.rerender('cc38854a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4m2f5diDqYNAV/JS/comp/SearchFilterTokens.vue"
export default component.exports